/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';

import {
  BaSeButton,
  BaSeHeading4,
  BaSePopover,
  BaSeShapeButton,
  BaSeTheme
} from '@base/react';
import { ContentSelectEmpretecMobile, TextAction } from './style';

import LOGO_EMPRETEC_ARENA from '../../assets/arena.png';
import LOGO_EMPRETEC_RURAL from '../../assets/rural.png';
import LOGO_EMPRETEC_STARTUP from '../../assets/startup.png';
import LOGO_EMPRETEC_TRADICIONAL from '../../assets/tradicional.png';

import LOGO_EMPRETEC_ARENA_SELECTED from '../../assets/arena-selected.png';
import LOGO_EMPRETEC_TRADICIONAL_SELECTED from '../../assets/empretec-selected-tradicional.png';
import LOGO_EMPRETEC_ARENA_MOBILE_SELECTED from '../../assets/mobile-arena-selected.png';
import LOGO_EMPRETEC_RURAL_MOBILE_SELECTED from '../../assets/mobile-rural-selected.png';
import LOGO_EMPRETEC_STARTUP_MOBILE_SELECTED from '../../assets/mobile-startup-selected.png';
import LOGO_EMPRETEC_URBANO_MOBILE_SELECTED from '../../assets/mobile-urbano-selected.png';
import LOGO_EMPRETEC_RURAL_SELECTED from '../../assets/rural-selected.png';
import LOGO_EMPRETEC_STARTUP_SELECTED from '../../assets/startup-selected.png';
import { FormContext } from '../../hook/form-context';
import { useDisplay } from '../../hook/useDisplay';
import StepperActions from './stepper-actions';

const empreteclist = [
  {
    id: 1,
    normal: LOGO_EMPRETEC_TRADICIONAL,
    white: LOGO_EMPRETEC_TRADICIONAL_SELECTED,
    mobile: LOGO_EMPRETEC_URBANO_MOBILE_SELECTED,
  },

  {
    id: 3,
    normal: LOGO_EMPRETEC_ARENA,
    white: LOGO_EMPRETEC_ARENA_SELECTED,
    mobile: LOGO_EMPRETEC_ARENA_MOBILE_SELECTED,
  },
  {
    id: 2,
    normal: LOGO_EMPRETEC_STARTUP,
    white: LOGO_EMPRETEC_STARTUP_SELECTED,
    mobile: LOGO_EMPRETEC_STARTUP_MOBILE_SELECTED,
  },
  {
    id: 4,
    normal: LOGO_EMPRETEC_RURAL,
    white: LOGO_EMPRETEC_RURAL_SELECTED,
    mobile: LOGO_EMPRETEC_RURAL_MOBILE_SELECTED,
  },
];

function SelectEmpretecMobile({ handleMenuClick }) {
  const { isLargeDisplay } = useDisplay();

  const [open, setOpen] = React.useState(false)
  const { handleSelectEmpretec, empretecId, nextScreen, setNextScreen } =
    React.useContext(FormContext);

  if (nextScreen) {
    const imgEmpretecSelected = empreteclist.find(
      (image) => image.id === empretecId,
    );
    return <StepperActions imgEmpretecSelected={imgEmpretecSelected} />;
  }

  return (
    <div>
      <div>
        <BaSeHeading4 color={BaSeTheme.colors.defaultColors.white}>
          Escolha o <strong>Empretec</strong> mais adequado para você
        </BaSeHeading4>
        <div style={{ display: 'flex', justifyContent: 'center' }}>

          <BaSePopover
            color="default"
            delayToOpen={0}
            direction="neutral"
            handleClose={() => setOpen((prev) => !prev)}
            hasCloseButton
            renderContent={() => (
              <TextAction>
                Quer saber qual Empretec combina com você?  <br />Confira aqui as{' '}
                <strong
                  onClick={() => handleMenuClick()}
                  style={{
                    color: '#006BFF',
                    fontSize: '1em',
                    cursor: 'pointer',
                  }}
                >
                  versões
                </strong>
                .
              </TextAction>
            )}
            open={open}
            themeMode="light"
            title=""
          />
          <BaSeShapeButton
            onClick={() => setOpen((prev) => !prev)}
            size="medium"
            sizeIcon="medium"
            type="tertiary"
            color="#ffffff"
            nameIcon="exclamation-circle"

          />
        </div>
      </div>

      <ContentSelectEmpretecMobile>
        {empreteclist.map((image, index) => (
          // eslint-disable-next-line jsx-a11y/img-redundant-alt
          <img
            key={image.id}
            src={
              empretecId === image.id
                ? isLargeDisplay()
                  ? image.white
                  : image.mobile
                : image.normal
            }
            alt={`Image ${index + 1}`}
            onClick={() => handleSelectEmpretec(image.id)}
          />
        ))}
      </ContentSelectEmpretecMobile>

      {
        empretecId && (
          <BaSeButton
            borderRadius="max"
            buttonType="submit"
            overrideColors={{
              backgroundColor: '#fff',
              foreground: '#0000C9',
            }}
            leftIcon=""
            onClick={() => setNextScreen(true)}
            loadingText="Carregando…"
            size="big"
            width="100%"
            type="primary"
            value="Confirmar"
          />
        )
      }
    </div >
  );
}

export default SelectEmpretecMobile;
